import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserConfigService } from 'src/app/services/user-config.service';
import { UserAccess, UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-access-list',
  templateUrl: './user-access-list.component.html',
  styleUrls: ['./user-access-list.component.scss']
})
export class UserAccessListComponent implements OnInit {

  @Output() selected: EventEmitter<UserAccess> = new EventEmitter();
  public accesses: UserAccess[] = [];
  public selectedAccess: UserAccess;

  constructor(private user: UserService, private userConfig: UserConfigService) { }

  ngOnInit(): void {
    this.user.access().subscribe(accesses => {
      this.accesses = accesses;
    });
    // Get default access for current user
    this.selectedAccess = this.user.defaultAccess('sms');
  }

  public select(access: UserAccess) {
    this.selectedAccess = access;
    this.selected.emit(access);
  }

}
